/* 
  Com a composition API, podemos criar variáveis globais e reativas sem o VueX e sem os pontos negativos dos Mixins.
  
  Então, este composable substitui o LoadingModule.ts que era criado com VueX 
  e adiciona a função de iniciar automaticamente o loader quando há requisições pendentes no Axios.

  Se for preciso forçar o Loader para indicar um carregamento que não seja uma requisição:
  
  Após a importação, as funções podem ser usadas exatamente iguais a forma antiga

  import { useLoader } from '@/composables/useLoader';

  const loader = useLoader();

  loader.startLoader();
  loader.dismissLoader();
*/

import { computed, ref } from 'vue';

const _requisitionCount = ref(0);
const _forceDisableLoading = ref(false);
const _forceEnableLoading = ref(false);

export function useLoader() {
  function startLoader() {
    _forceEnableLoading.value = true;
  }

  function dismissLoader() {
    _forceEnableLoading.value = false;
  }

  const loading = computed(() => {
    if (_forceEnableLoading.value) {
      return true;
    }

    if (_forceDisableLoading.value) {
      return false;
    }

    return _requisitionCount.value > 0;
  });

  return {
    loading,
    startLoader,
    dismissLoader,
  };
}

/**
 * Função criada apenas para ser usada de middleware no axios.
 */
export function incrementRequisition() {
  _requisitionCount.value++;
}

/**
 * Função criada apenas para ser usada de middleware no axios.
 */
export function decrementRequisition() {
  _requisitionCount.value--;
}
